import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { CarouselModule, IconModule, KeyboardFocusModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { HighlightPipe } from './highlight.pipe';
import { HisenseSearchBoxComponent } from './search-box.component';

@NgModule({
  declarations: [HisenseSearchBoxComponent, HighlightPipe],
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    OutletModule,
    FeaturesConfigModule,
    CarouselModule,
    KeyboardFocusModule,
  ],
  exports: [HisenseSearchBoxComponent, HighlightPipe],
})
export class SearchBoxModule {}
